import { render, staticRenderFns } from "./ShopSelection.vue?vue&type=template&id=6ffe3d5f&scoped=true&"
import script from "./ShopSelection.vue?vue&type=script&lang=js&"
export * from "./ShopSelection.vue?vue&type=script&lang=js&"
import style0 from "./ShopSelection.vue?vue&type=style&index=0&id=6ffe3d5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe3d5f",
  null
  
)

export default component.exports